import { useAuthContext } from 'hooks/useAuthContext';
import React from 'react';
import { H4 } from './elements';

const TitleHeader = () => {
  const { userData } = useAuthContext();
  return (
    <>
      <H4>
        {userData.userType === 'country'
          ? `${userData.displayName}`
          : userData.userType === 'region'
          ? `${userData.regionName}`
          : `${userData.regionName}, ${userData.department}`}
      </H4>
    </>
  );
};

export default TitleHeader;
